"use strict";
import "lodash";
import { svc_fetchAll, svc_addOne, svc_editOne, svc_deleteOne, svc_search } from "@/services";
import { showServerResponse } from "@/utils/message";
import logger from "@/utils/logger";

const endpointBasePrefix = "suppliers";

const Model = {
	namespace: "m_Suppliers",
	state: {
		suppliers: [],
	},
	reducers: {
		handleFetchAll(state, { payload: { suppliers } }) {
			return { ...state, suppliers };
		},
	},
	effects: {
		*fetchAll({ payload }, { call, put }) {
			let suppliers = yield call(svc_search, endpointBasePrefix, payload);
			
			_.forEach(suppliers, function (row) {
				row.key = row.id;
			});

			yield put({
				type: "handleFetchAll",
				payload: { suppliers },
			});

			return suppliers;
		},
		*addOne({ payload }, { call, put }) {
			payload = _.omit(payload, ["key"]);
			const response = yield call(svc_addOne, endpointBasePrefix, payload, payload.company_name);
			return showServerResponse(response);
		},
		*editOne({ payload }, { call, put }) {
			payload = _.omit(payload, ["key"]);
			const response = yield call(
				svc_editOne,
				endpointBasePrefix,
				payload,
				"id",
				payload.name,
			);
			return showServerResponse(response);
		},
		*deleteOne({ payload }, { call, put }) {
			payload = _.omit(payload, ["key"]);
			const response = yield call(
				svc_deleteOne,
				endpointBasePrefix,
				payload,
				"id",
				payload.name,
			);
			return showServerResponse(response);
		},
	},
	subscriptions: {},
};

export default Model;
